import { createEmptyFetchable } from 'helpers/loadableHelpers'
import { Reducer } from 'interfaces'
import { CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'
import { JoinCCWaitlistAction } from 'components/features/creditCard/creditCardStore/actions'

const INITIAL_STATE = createEmptyFetchable<null>()
export const waitlistRequestReducer: Reducer<CreditCardAppState['waitlistRequest']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case JoinCCWaitlistAction.type: {
      if (action.meta === 'request') {
        return {
          isLoading: true,
          errorCode: null,
          data: null,
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          errorCode: action.payload.errorCode,
          errorsMap: action.payload.errorsMap,
        }
      }

      return {
        isLoading: false,
        errorCode: null,
        data: null,
      }
    }
  }
  return prevState
}
